<template>
  <MenuComponent
    :filtred_count="itemCount">
    <template #navbar="{ navbarMini }">
      <TendersNavBar
        ref="navBar"
        data-qa="tenders-navBar"
        :disabled="loading.tenders || loading.statics"
        :loading="loading.statics"
        :mini="navbarMini"
        :statistics="tender_counts"
        :types="filter_types"
        :value="searchFilters"
        @update:value="setSearchFilters"/>
    </template>
    <template #filter>
      <TendersToolbarFilter
        ref="toolbar"
        :all-headers="headers"
        data-qa="tenders-toolbar-filter"
        :filters="searchFilters"
        :item-count="tender_counts.tendersCount"
        :items="items"
        :loading="loading.tenders"
        :table-mode="tableProps.mode"
        @update:filters="setSearchFilters"
        @update:tableMode="changeTableMode"/>
    </template>
    <template #items>
      <TendersTags
        :filters="searchFilters"
        :spr="spr"
        @update:filters="setSearchFilters"/>
      <EmptyBlock
        v-if="!loading.tenders && (!groups || !groups.length)"
        data-qa="tenders-no-data"
        :text="emptyBlockText"/>
      <Groups
        v-else-if="items && items.length"
        ref="tenders_groups"
        can_expand
        class="pt-4 groups"
        content_class="pt-2 pb-2"
        :group_view.sync="tableProps.headers"
        :group_view_variants="tableProps.mode ? headers.filter(el => el.text && !el.disableFilter) : null"
        :grouped-by_types="groupItems.types"
        :grouped_by.sync="groupItems.current"
        :groups="groups"
        :scroller="tableProps.mode"
        :watch-changed-groups="watchChangedGroups"
        with_title
        @update:expanded="updExpandedGroups"
        @update:group_view="updheaders"
        @update:grouped_by="updGroupType">
        <template
          #title="{ group, index }">
          <div
            class="tender-title period-name h4-headline text-start"
            :data-qa="`item-${index}-name`">
            {{ $_capitalizeFirstLetter(group.title) }}
          </div>
        </template>
        <template #content="{ group, index }">
          <template
            v-if="tableProps.mode && tableProps.headers && group">
            <TendersTable
              ref="tender_table"
              :all-headers="tableProps.headers"
              :choosed.sync="choosed[group.title]"
              :choosed-headers="tableProps.headers"
              :data-qa="`item-${index}-table`"
              :group="group"
              :items="group.items"
              :load_agreement="loading.agreements"
              :stages="agreements"
              @click-info="showInfo"/>
          </template>
          <template
            v-else>
            <TenderCard
              v-for="(tender, n) in group.items"
              :key="tender.tenderId"
              ref="tender_card"
              :data-qa="`item-${index}-card`"
              :last="n == (items.length - 1)"
              :load_agreement="loading.agreements"
              :stages="agreements[tender.tenderId] || []"
              :tender="tender"
              wait_load
              @click-info="showInfo"/>
          </template>
        </template>
      </Groups>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="!loading.tenders && items.length != itemCount && !emptyElastic"
        call-on-mount
        class="mt-3"
        :loading="loading.tenders"/>
      <sModal
        :mask-closable="false"
        :title="$t('Tenders.acceptorHistory')"
        :value="!!acceptorData"
        @close="acceptorData = null">
        <SpilkaFormioMF
          v-if="acceptorData && acceptorData.version"
          class="ml-2"
          disabled
          :form-params="acceptorData"
          :hide-submit="true"/>
        <SpilkaFormioMFOld
          v-else-if="acceptorData"
          class="ml-2"
          :form-params="acceptorData"
          :hide-submit="true"/>
        <div
          key="footer"
          slot="footer">
          <sButton
            data-qa="btn-close"
            type="text"
            @click="acceptorData = null">
            {{ $t('Common.Close') }}
          </sButton>
        </div>
      </sModal>
    </template>
  </MenuComponent>
</template>
<script>
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()
import { debounce } from 'toolkit/utils/util'

import MenuComponent from 'pages/templates/MenuComponent.vue'
import Groups from 'components/common/blocks/groups/Groups.vue'
import SpilkaFormioMF from 'components/common/SpilkaFormioMF.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import TenderCard from 'components/tenders/all tenders/TenderCard.vue'
import SpilkaFormioMFOld from 'components/common/SpilkaFormioMFOld.vue'
import TendersTable from 'components/tenders/all tenders/TendersTable.vue'
import TendersNavBar from 'components/tenders/all tenders/TendersNavBar.vue'
import TendersTags from 'components/tenders/all tenders/TenderTags.vue'
import TendersToolbarFilter from 'components/tenders/all tenders/TendersToolbarFilter.vue'


import textFunctions from 'mixins/textFunctions'
import tableMixin from 'mixins/tableMixin'
import functionMixin from 'mixins/functionMixin'
import godModeMixin from 'mixins/godModeMixin'

import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'tenders',
  mixins: [
    godModeMixin,
    textFunctions,
    tableMixin,
    functionMixin,
  ],
  data() {
    return {
      pageProps: { // Данные страницы
        page: 0, // текущая страница
        countOnPage: 5, // количество на странице
      },
      tableProps: {
        mode: false, // табличный вид данных
        headers: [], // Колонки выбранные у таблица
      },
      loading: { // Индикаторы загрузки
        tenders: true, // тендеры
        statics: true, // статистика
        agreements: false, // согласованты
      },
      expanded: null, // развернутые группы
      searchFilters: {
        tenderSearchParam: {
          searchType: 'NONE', // тип поиска NONE NONE/BY_PHRASE/BY_IDENTIFIER
          phrase: '',
          initialRateFrom: null,
          initialRateTo: null,
          withScheduledPublicationDate: false,
          containsFilter: {},
          notContainFilter: {},
          queryMergeType: 'AND',
        },
        additionalFilter: 'TENDERS',
        sort: 'SMART_RANK'
      },
      agreements: {},
      tariff: '', // текущий тариф
      choosed: {},
      spr: {
        departments: [],
        organizations: [],
        biddingTypes: [],
        contactPeople: [],
        personalManagers: []
      },

      //startProp: {}, // Данные с прошлого входа
      headers: [],
      groupItems: { // Данные для группировки
        current: {
          text: this.$t('Tenders.AllTenders'),
          value: 'all',
        },
        types: [
          {text: this.$t('Tenders.ByMonth'), value: 'byMonth'},
          {text: this.$t('Tenders.AllTenders'), value: 'all'},
        ]
      },
      emptyElastic: false, // якщо по кількості заявленій в еластіку менше тендерів ніж прийшло , щаб е було додаткових безкінечних запитів з отриманням пустого масиву
      acceptorData: null,
    }
  },
  methods: {
    showInfo(acceptorData) {
      this.acceptorData = acceptorData
    },
    /**
    * Конверт модели шаблонна фильтров в модель для запроса
    */
    setTemplateFilters({filters, mode}) {
      let getFilter = items => {
        let result = {}
        items.forEach((filter) => {
          switch (filter.type) {
          case 'tenderStatuses':
          case 'departmentIds':
          case 'contactIds':
          case 'tariffUserIds':
          case 'contactPersonDepartment':
          case 'biddingTypeCodes':
          case 'organizationIds':
          case 'categoryIds': {
            const conditions = filter.search[0] !== null && typeof filter.search[0] === 'object'
            result[filter.type] ||= []
            let value = conditions ? filter.search.map(el => el.classificationCode) : filter.search
            result[filter.type].push(...value)
            break
          }
          case 'publication':
          case 'dateAdded':
          case 'contractDate':
          case 'tenderingEndDate': {
            result[filter.type] = {
              from: filter.search[0],
              to: filter.search[1],
            }
            break
          }
          }
        })
        return result
      }
      let containsFilter = {}
      let notContainFilter = {}
      Object.entries(this.$_.groupBy(filters, 'contain')).forEach(([name, items]) => {
        let filter = getFilter(items)
        if (name === 'true') {
          containsFilter = filter
        } else {
          notContainFilter = filter
        }
      })
      const newSearchFilters = this.$_.cloneDeep(this.searchFilters)
      newSearchFilters.tenderSearchParam.containsFilter = containsFilter
      newSearchFilters.tenderSearchParam.notContainFilter = notContainFilter

      if (!Object.keys(containsFilter).length && !Object.keys(notContainFilter).length) {
        newSearchFilters.tenderSearchParam.queryMergeType = 'AND'
      } else {
        newSearchFilters.tenderSearchParam.queryMergeType = mode ? 'AND' : 'OR'
      }
      this.setSearchFilters(newSearchFilters)
    },
    fullLoading() {
      this.loadTenders(1)
      this.getTenderStatistic()
    },
    loadTenders: debounce(async function (page) {
      this.loading.tenders = true

      this.pageProps.page = page
      const tenderSearchParam = this.searchFilters.tenderSearchParam
      const additionalFilter = this.searchFilters.additionalFilter || 'TENDERS'
      const size = this.pageProps.countOnPage > 0 ? this.pageProps.countOnPage : 0
      const sort = this.searchFilters.sort || 'SMART_RANK'
      const searchParams = {tenderSearchParam, additionalFilter, page: this.pageProps.page, size, sort}

      if (this.pageProps.page === 1) {
        this.$store.commit('setTenders', [])
      }

      await this.$store.dispatch('tendersSearch', searchParams)
        .then(res => {
          if (!res) { return }
          let tenders = []
          this.$store.commit('setTendersCount', res?.tendersCount || 0)

          if (this.pageProps.page === 1) {
            tenders = res?.tenders || []
          } else {
            tenders = [...this.items || [], ...res?.tenders || []]
          }
          tenders = this.$_.uniqBy(tenders, 'tenderId')
          this.$store.commit('setTenders', tenders)
          if (!res?.tenders?.length) {
            this.emptyElastic = true
            return
          } else {
            this.emptyElastic = false
          }

          let ids = res.tenders?.map(tender => tender.tenderId)

          if (ids?.length) {
            this.loading.agreements = true
            this.$store.dispatch('actualAgreementsByTenders', ids)
              .then(res => {
                if (res?.length) {
                  res.forEach((item) => {
                    this.$set(this.agreements, item.tenderId, item.agreements)
                  })
                }
              }).
              finally(() => {
                this.loading.agreements = false
              })
          }
        })
        .finally(() => {
          this.$_savePropToDBStorage('tenders_filters', searchParams)
          this.loading.tenders = false
        })
    }, 250),
    getTenderStatistic: debounce(function () {
      this.loading.statics = true
      return new Promise((resolve) => {
        this.$store.dispatch('tendersStatistic', {...this.searchFilters.tenderSearchParam})
          .then(res => {
            this.$store.commit('settendersCountsByTypes', res || { })
          })
          .finally(() => {
            this.loading.statics = false
            resolve()
          })

      })
    }, 250),
    /**
   * Формируем заголовки столбцов для табличного вида
   */
    async createHeaders() {
      if (this.$acl.check('isGoodMode') || this.tableProps.mode) {
        await tender_api.getDepartments(this.mixin_isGodMode ? [] : [+this.storedCurrentOrganization.organizationItId])
          .then(response => {
            this.$store.commit('setDepartmentsToState', response)
            this.spr.departments = response
          })
      }

      const countDepartments = this.$store.getters.getDepartments?.length

      this.headers = [
        {text: '', value: 'data-table-select', width: '50px' },
        {text: this.$t('Planning.Name'), value: 'tenderSubject', coef_width: '3', disableFilter: true, sortable: true,},
        {text: this.$t('Tenders.Category'), value: 'categoryTitle', coef_width: '3', sortable: true, setFilter: true, type: 'categoryIds'},
        {text: this.$t('Tenders.TenderType'), value: 'biddingTypeTitle', coef_width: '2.5', sortable: true, setFilter: true, type: 'biddingTypeCodes'},
        {text: this.$t('Purchasing.Status'), value: 'tenderStatusTitle', coef_width: '3', sortable: true, setFilter: true, type: 'tenderStatuses'},
        {text: this.$t('Common.Organization'), value: 'organizer.title', coef_width: '2', sortable: true, setFilter: false, type: 'organizationIds'},
        {text: this.$t('Common.Department'), value: 'contactPersonDepartment', coef_width: '2', sortable: true, setFilter: countDepartments > 1, type: 'departmentIds'},
        {text: this.$_capitalizeFirstLetter(this.$t('Tenders.ContactPerson')), value: 'contactPersonName', coef_width: '2', sortable: true, setFilter: false, type: 'contactPersonName'},
        {text: this.$t('Tenders.DateOfCreation'), value: 'tenderCreatedDate', coef_width: '2.5', sortable: true, setFilter: true, type: 'dateAdded'},
        {text: this.$t('Tenders.PublicationDate'), value: 'publishedDate', coef_width: '2.5', sortable: true, setFilter: true, type: 'publication'},
        {text: this.$t('Tenders.ContractDate'), value: 'contractDate', setFilter: true, type: 'contractDate'},
        {text: this.$t('Tenders.TenderEndDate'), value: 'archiveDate', coef_width: '2.5', sortable: true },
        {text: this.$_capitalizeFirstLetter(this.$t('Tenders.DateTo')), value: 'tenderingPeriodEnd', coef_width: '2', sortable: true, setFilter: true, type: 'tenderingEndDate'},
        {text: this.$t('Tenders.Budget'), value: 'tenderBudjet', coef_width: '2', sortable: true,},
        {text: this.$t('Tenders.purchaseAmount'), value: 'purchaseAmount', coef_width: '1', sortable: true, },
        {text: this.$t('Tenders.Profit'), value: 'economy', coef_width: '1', sortable: true, },
        {text: this.$t('Tenders.Members'), value: 'bidsCount', width: '50px', sortable: true, }
      ]
      if (this.$can('set', 'tenderViews')) {
        this.headers.push({text: this.$t('Tenders.Views1'), value: 'viewsCount', width: '50px', sortable: true, })
      }
      this.headers.forEach((el, i) => el.id = i)

      this.$_getPropFromDBStorage('tenders_headers', null)
        .then((localHeaders) => {
          if (localHeaders?.length) {
            this.tableProps.headers = localHeaders?.map(el => this.headers.find(it => it?.value == el?.value))?.filter(el => el)
          } else {
            this.tableProps.headers = this.headers.slice(0).filter(el => el.value != 'organizer.title')
          }
          this.$_getHeadersWidthByCoef(this.tableProps.headers)
        })
    },
    getTariff() {
      this.$store.dispatch('getContractNumberAndTariff')
        .then(res => {
          this.tariff = res?.tariff
        })
    },
    updheaders() {
      if (!this.tableProps.mode) { return }

      this.$_getHeadersWidthByCoef(this.tableProps.headers)

      this.$nextTick(() => {
        let tables = this.$el.querySelectorAll('.tenders-table')
        let cells = []
        tables.forEach(table => {
          let ths = table.querySelectorAll('th')
          cells.push([...ths])
        })
        let max_cells = this.tableProps.headers.map((header, i) => {
          let resized = header.resizedWidth || 0,
            max = Math.max(...cells.map(it => it[i].offsetWidth))
          return Math.max(max, resized)
        })
        tables.forEach(table => {
          let ths = table.querySelectorAll('th')
          ths.forEach((th, i) => {
            th.style.minWidth = this.tableProps.headers[i].value == 'data-table-select' ? 50 : max_cells[i] + 'px'
          })
          let resize = table.querySelectorAll('.resize-column')
          resize.forEach(element => {
            element.style.height = table.offsetHeight - 5 + 'px'
          })
        })

        const checkColumn = (columnName, columns, index) => {
          const column = this.$_.cloneDeep(this.headers.find(i => i.value === columnName))
          if (column && !this.tableProps.headers.find(i => i.value === column.value)) {
            columns.splice(index, 0, column)
          }
        }
        const checkDoubles = (columns) => {
          let hasError = false
          columns.forEach(item => {
            let count = columns.filter(i => i.value === item.value)?.length
            if (count > 1) {
              hasError = true
            }
          })
          if (hasError) {
            return this.$_.cloneDeep(this.headers)
          } else {
            return columns
          }
        }

        checkColumn('data-table-select', this.tableProps.headers, 0)
        checkColumn('tenderSubject', this.tableProps.headers, 1)

        this.tableProps.headers = checkDoubles(this.tableProps.headers)

        this.$_savePropToDBStorage('tenders_headers', this.tableProps.headers)

        this.$refs?.tenders_groups?.updateObserver(true)
      })
    },
    /**
   * Наполняем справочники
   */
    async getBidTypeAndContacts() {
      const promises = []

      const biddingTypesPromise = this.$store.dispatch('setBiddingTypes')
      promises.push(biddingTypesPromise)

      let tenderStatusesPromise
      if (!this.stateLoading.status) {
        tenderStatusesPromise = this.$store.dispatch('setTenderStatuses', true)
        promises.push(tenderStatusesPromise)
      }

      const contactPeoplePromise = this.$store.dispatch('tenderContactPersons')
      promises.push(contactPeoplePromise)

      let personalManagersPromise
      if (this.$acl.check('isGoodMode')) {
        personalManagersPromise = this.$store.dispatch('personalManagers')
        promises.push(personalManagersPromise)
      }

      const organizationsPromise = this.$store.dispatch('availableOrganizationsForCurrently')
      promises.push(organizationsPromise)

      await Promise.all(promises)

      this.spr.biddingTypes = this.$store.getters.getBiddingTypes
      this.spr.contactPeople = await contactPeoplePromise
      if (personalManagersPromise) {
        this.spr.personalManagers = await personalManagersPromise
      }
      this.spr.organizations = await organizationsPromise
    },
    /** определяем сколько тендеров влазит на страницу */
    setSize() {
      let elm = this.$el || document.getElementById('tenders') || this.$root.$el
      const countOnPage = Math.floor((elm?.clientHeight - 64) / (this.tableProps.mode ? 60 : 150)) || 0
      this.pageProps.countOnPage = countOnPage >= 4 ? countOnPage : 4
    },
    /**
   * Заполняем статусы разворота строк
   */
    watchChangedGroups(old, new_val, expanded) {
      let result = []
      if (!this.expanded) {
        result = this.$_.cloneDeep(new_val)
      } else {
        let groups = this.$_.xorBy(new_val, old, 'id')
        result = expanded.concat(groups)
      }

      this.expanded = result
      return result
    },
    /**
   * Изменяем группировку
   */
    updGroupType(val) {
      this.$_savePropToDBStorage('tenders_groupType', val.value)
      if (val?.value != 'all') {
        this.updheaders()
      }
    },
    /**
   * Для табличного вида
   * посмотреть, разобраться
   */
    updExpandedGroups(expanded, group, open) {
      if (this.groupItems.current?.value != 'all') {
        if (!open) {
          this.$nextTick(this.$refs?.infinity_updater?.handleScroll)
        } else {
          this.updheaders()
        }
      }

      this.expanded = expanded
    },
    infinityLoad() {
      if (this.groupItems.current?.value == 'all' && !this.expanded?.length) { return }
      if (this.items.length < this.itemCount && this.itemCount) {
        this.loadTenders(this.pageProps.page + 1)
      }
    },
    async changeTableMode(val) {
      this.choosed = []
      this.tableProps.mode = val
      this.$_savePropToDBStorage('tenders_tableMode', val)
      await this.setSize()
      this.$root.$emit('closeSnackbar')

      const countItem = this.groups?.length ? this.groups
        .map(i => i.items?.length || 0)
        .reduce((a, b) => a + b, 0) : 0

      if (countItem && this.pageProps.page) {
        this.pageProps.page = Math.floor(countItem / this.pageProps.countOnPage)
      }

      if (this.pageProps.countOnPage > countItem) {
        this.infinityLoad()
      } else if (val) {
        this.updheaders()
      }

    },
    async setSearchFilters(value) {
      const result = await this.checkFilterTypes(value)
      const changeFilters = this.$_compareObjects(result, this.searchFilters)

      if (changeFilters?.length === 0) {
        return
      }

      let isFullLoading = false

      if (changeFilters.length > 0) {
        const additionalFilterChanged = changeFilters.every(key => key === 'additionalFilter')
        if (additionalFilterChanged && changeFilters.length === 1) { // если изменили только пункт меню, статистику считывать не нужно
          isFullLoading = false
        } else {
          isFullLoading = true
        }
      }

      this.$set(this, 'searchFilters', result)
      this.$nextTick(() => {
        if (isFullLoading) {
          this.fullLoading()
        } else {
          this.loadTenders(1)
        }
      })
    },
    /**
   * Проверяем фильтр на доступность параметров
   */
    async checkFilterTypes(innerFilters) {
      //Список фильтров для проверки допустимых значений
      const checkFilters = {
        biddingTypeCodes: {spr: this.spr.biddingTypes, key: 'biddingTypeId'},
        contactIds: {spr: this.spr.contactPeople, key: 'contactId'},
        departmentIds: {spr: this.spr.departments, key: 'id'},
        organizationIds: {spr: this.spr.organizations, key: 'organizationItId'},
        tariffUserIds: {spr: this.spr.personalManagers, key: 'userId'},
        tenderStatuses: {spr: this.statuses, key: 'statusCode'},
      }
      let checkBy = (search, {spr, key}) => {
        if (!search) {
          return search
        }
        return search.filter(val => spr.some(el => el[key] == val) )
      }

      const checkActualFilters = async (filter) => {
        if (!filter || !Object.keys(filter).length) {
          return
        }
        const result = {}
        Object.entries(filter).forEach(([key, value]) => {
          if (!Object.keys(checkFilters).includes(key)) {
            result[key] = value
            return
          }
          if (!this.mixin_isGodMode && key === 'tariffUserIds') { // Данный фильтр только для админов
            return
          }
          if (this.mixin_isGodMode && key === 'departmentIds') { // Данный фильтр недоступен в режиме админа
            return
          }
          value = checkBy(value, checkFilters[key])

          if (!value || (typeof value === 'object' && !Object.values(value).length)) { // фильтр без данных не корректен
            return
          }
          result[key] = value
        })
        return result
      }

      innerFilters.tenderSearchParam.containsFilter = await checkActualFilters(innerFilters.tenderSearchParam.containsFilter)
      innerFilters.tenderSearchParam.notContainFilter = await checkActualFilters(innerFilters.tenderSearchParam.notContainFilter)
      return innerFilters
    },
    saveActiveTemplateFilters(value) {
      if (!value) { return }
      this.$_savePropToDBStorage('tenders_template_filters', value)
    },
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
      changeOrganisation: 'changeOrganisation',
      storedCurrentOrganization: 'getCurrentOrganization',
      itemCount: 'getTendersCount',
      tender_counts: 'gettendersCountsByTypes',
      items: 'getTenders'
    }),
    ...mapGetters({
      statuses: 'getTenderStatuses',
      stateLoading: 'getStateLoading',
    }),
    stored_filters() {
      let filters = this.$store.getters.getFilters.TENDERS
      return filters
    },
    /**
   * Текст для блока пустых данных
   */
    emptyBlockText() {
      return !this.tariff ? this.$t('Tenders.NowYouHaveOpportunityToAcquaintedBasicFunctionality') : this.$t('Tenders.NoResultsForSearch')
    },
    filter_types() {
      let items = [{
        name: 'Tenders.Tenders',
        icon: 'table',
        type: 'TENDERS',
        count: 'tendersCount',
      },
      {
        name: 'Tenders.NewComments',
        type: 'WITH_NEW_COMMENTS' ,
        count: 'newCommentsCount',
        class: 'pl-7',
        icon: 'comment',
      },
      {
        name: 'Tenders.Expect',
        type: 'WAIT_MY_AGREE' ,
        count: 'waitMyAgreeCount',
        class: 'pl-7',
        icon: 'person-check',
      },
      {
        name: 'Tenders.NoOffers',
        type: 'WITHOUT_PROPOSAL' ,
        count: 'withoutProposalCount',
        class: 'pl-7',
      },
      {
        name: 'Tenders.EndSoon',
        type: 'ENDED_SOON' ,
        count: 'endedSoonCount',
        class: 'pl-7',
      },
      {
        name: 'Tenders.MyTenders',
        type: 'MY_TENDERS' ,
        count: 'myTradesCount',
        class: 'pl-7',
        icon: 'person',
      },
      {
        name: 'Purchasing.Templates',
        type: 'TEMPLATES',
        icon: 'draft',
        count: 'templatesCount',
      },
      {
        name: 'Tenders.ScheduledPublication',
        type: 'SCHEDULED',
        count: 'schedulersCount',
        icon: 'time-ending',
      },
      {
        name: 'Purchasing.Drafts',
        type: 'DRAFTS' ,
        count: 'draftsCount',
        icon: 'edit',
      },
      ]
      return items
    },
    choosed_items() {
      let choosed = []
      Object.values(this.choosed).forEach(el => choosed.push(...el))
      return choosed
    },
    groups() {
      if (!this.groupItems.current?.value || !this.items?.length) {
        return []
      }
      if (this.groupItems.current?.value == 'all') {
        return [
          {
            id: this.groupItems.current?.value,
            title: this.groupItems.current?.text,
            items: this.items.slice(0),
            choosed: []
          }
        ]
      }
      let endedSoon = this.findItemsByGroup.map(e => e.tenderId),
        groupByPeriod = (item) => {
          let date = moment(item.tenderingPeriodEnd)
          return date.isValid() ? !this.$_.some(endedSoon, el => el == item.tenderId) ? date.format('YYYYMM') : '999999' : '000000'
        },
        tenders = this.items.slice(0),
        groupping = this.$_.groupBy(tenders, groupByPeriod),
        groups = []

      for (const key in groupping) {
        if (groupping.hasOwnProperty(key)) {
          const el = groupping[key]
          groups.push({
            id: parseInt(key),
            title: key == '999999'
              ? this.$t('Tenders.EndSoon')
              : key == '000000'
                ? this.$t('Common.WithoutDate')
                : moment(key).format('MMMM YYYY'),
            items: el.slice(0),
            choosed: []
          })
        }
      }
      groups.sort((a,b) => a.id < b.id ? 1 : -1)

      return groups
    },
    findItemsByGroup() {
      let filtred = this.$_.filter(this.items, el => {
        if (el.tenderStatusId != 4) {
          return false
        }
        let this_week = Date.parse(moment().add(7, 'days').format('YYYY-MM-DD')),
          now = Date.parse(moment().format('YYYY-MM-DD')),
          end_date = Date.parse(el.tenderingPeriodEnd)
        if (this_week > end_date && end_date > now) {
          return true
        }
        return false
      })
      return filtred
    },
    pages() {
      return Math.ceil(this.itemCount / this.pageProps.countOnPage)
    },
  },
  watch: {
    choosed_items(val) {
      if (val.length > 0) {
        this.$root.$emit('showSnackbar', {
          name: 'tenders',
          elements: val,
          callback: () => {
            this.choosed = {}
          }
        })
      } else if (val.length == 0) {
        this.$root.$emit('closeSnackbar')
      }
    },
    async changeOrganisation(val) {
      this.$store.commit('setDepartmentsToState', [])
      this.$store.commit('setTenders', [])
      this.$store.commit('setTendersCount', 0)
      this.$store.commit('settendersCountsByTypes', {})
      this.$root.$emit('closeSnackbar')
      this.choosed = []
      if (!val && this.settings.hasTenderAccess) {
        await this.createHeaders()
        this.getTariff()
        await this.getBidTypeAndContacts()
        await this.setSearchFilters(this.searchFilters)
        this.fullLoading()
      }
    },
  },
  async mounted() {
    this.getTariff()
    await this.getBidTypeAndContacts()

    await this.$_getPropFromDBStorage('tenders_tableMode', false)
      .then((tableMode) => {
        this.tableProps.mode = !!tableMode
      })
    this.$_getPropFromDBStorage('tenders_groupType', 'byMonth')
      .then((groupedBy) => {
        this.groupItems.current = groupedBy ? this.groupItems.types.find(el => el.value == groupedBy) : this.groupItems.types[0]
      })
    await this.setSize()
    await this.$_getPropFromDBStorage('tenders_filters', {})
      .then(async (storage_filters) => {
        if (storage_filters && !storage_filters?.filters) {
          const result = this.$_.cloneDeep(this.searchFilters) || {}
          result.tenderSearchParam = {
            ...result.tenderSearchParam,
            ...storage_filters?.tenderSearchParam || {}
          }
          result.tenderSearchParam.phrase = storage_filters?.tenderSearchParam?.phrase
          result.tenderSearchParam.queryMergeType = result.tenderSearchParam?.queryMergeType || 'AND'
          result.additionalFilter = storage_filters.additionalFilter || 'TENDERS',
          result.sort = storage_filters.sort || 'SMART_RANK'

          this.setSearchFilters(result)
        }
      })
    await this.createHeaders()
    this.fullLoading()


    this.$_getPropFromDBStorage('tenders_template_filters', null)
      .then((result) => {
        this.$root.$emit('setActiveTemplateFilters', result)
      })

    this.$root.$on('refreshTendersPage', this.fullLoading)
    this.$root.$on('setTemplateFilters', this.setTemplateFilters)
    this.$root.$on('setActiveTemplateFilters', this.saveActiveTemplateFilters)
  },
  beforeDestroy() {
    this.$root.$off('refreshTendersPage', this.fullLoading)
    this.$root.$off('setTemplateFilters', this.setTemplateFilters)
    this.$root.$off('setActiveTemplateFilters', this.saveActiveTemplateFilters)
  //this.$store.commit('setTenders', [])
  //this.$store.commit('setTendersCount', 0)
  //this.$store.commit('settendersCountsByTypes', {})
  //this.$store.commit('setAgreements', {items: []})
  //this.$root.$off('loadData', this.fullLoading)
  },
  components: {
    Groups,
    TenderCard,
    EmptyBlock,
    TendersTags,
    TendersTable,
    TendersNavBar,
    MenuComponent,
    InfinityUpdater,
    TendersToolbarFilter,
    SpilkaFormioMF,
    SpilkaFormioMFOld,
  }
}
</script>
<style lang="scss" scoped>
.period-name {
 color: var(--text-color);
 font-weight: 500;
 font-size: 17px;

}
.sticky {
 z-index: 6;
 position: sticky;
 top: 64px !important;

 &.tender-title {
  top: 138px !important;
  z-index: 5;
  height: 70px;
 }
}
.tender-title {
 font-size: 14px;
}

.amount {
 font-weight: 500;
 font-size: 54px;
 line-height: 56px;
}

.empty-tenders {

 border-radius: 8px !important;
 width: 100%;

  div {
   color: black !important;
  }
 .title {
  font-weight: 500;
  font-size: 32px !important;
 }
 .list {
  background-color: transparent;
  .item {
   font-size: 24px;
  }
 }
}

.create-in-menu {
 cursor: pointer;
}
button.outlined-btn.v-btn.v-btn--outlined.black-outlined-btn.v-btn--active {
 border-color: transparent !important;
 &::before {
  opacity: 0;
 }
}
</style>
<style lang="scss">
.tenders-panel-table {
 .v-expansion-panel-content__wrap{

  display: flex;
  justify-content: center;
  padding-bottom: 10px !important;
  overflow-x: auto;
 }
}
</style>
